import React, { useState, useEffect } from 'react';
import { Button, ConfigProvider, Dropdown, Layout, Menu, message, theme } from 'antd';
import {
    AppstoreAddOutlined,
    CommentOutlined,
    DoubleLeftOutlined,
    DoubleRightOutlined,
    FileSyncOutlined,
    LineChartOutlined,
    LogoutOutlined,
    PieChartOutlined,
    SettingOutlined,
    UserOutlined,
} from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { AuthData } from './Global';
import LiveChat from './LiveChat';
import { GetTran } from '../API/GetData';

const { Header, Content, Footer, Sider } = Layout;

const Layouts = ({ children }) => {
    const navigate = useNavigate();
    const userData = AuthData();

    const Role = userData && userData.Role;

    const [collapsed, setCollapsed] = useState(false);
    const [mobile, setMobile] = useState(window.innerWidth <= 768);
    const [selectedKeys, setSelectedKeys] = useState(["1"]);
    const [openKeys, setOpenKeys] = useState();

    const [Tran, setTran] = useState([]);

    useEffect(() => {
        const fetchTran = async () => {
            try {
                const response = await GetTran();
                setTran(response);
            } catch (error) {
                console.log(error);
            }
        };
        fetchTran();
    }, []);


    useEffect(() => {
        const handleResize = () => {
            setMobile(window.innerWidth <= 768);
        };
        if (mobile) {
            setCollapsed(true);
        } else {
            setCollapsed(false);
        }
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [mobile]);

    useEffect(() => {
        // Read the selected key and open keys from localStorage
        const storedSelectedKey = localStorage.getItem('selectedMenuKey');
        const storedOpenKeys = localStorage.getItem('openMenuKeys');

        if (storedSelectedKey) {
            setSelectedKeys([storedSelectedKey]);
        }

        if (storedOpenKeys) {
            setOpenKeys(JSON.parse(storedOpenKeys));
        }
    }, []);

    // Custom theme configuration
    const customTheme = {
        token: {
            colorPrimary: '#FFC700',
            colorText: '#000000',
            fontFamily: '"Neo Sans Pro", sans-serif',
        },
        components: {
            Menu: {
                itemColor: '#000000',
                itemHoverColor: '#000000',
                itemSelectedColor: '#000000',
                itemActiveColor: '#000000',

                itemBg: '#FFC700',
                itemHoverBg: '#fff4cc', // warna hover
                itemSelectedBg: '#fff4cc', // saat dipilih
                itemActiveBg: '#FFC700', // saat aktif (misal submenu terbuka)

                subMenuItemBg: '#FFC700', // isi submenu

                // Tambahan untuk submenu title
                subMenuItemColor: '#000000',
                subMenuItemHoverColor: '#000000',
                subMenuItemSelectedColor: '#000000',
            },
            Tabs: {
                itemSelectedColor: '#21b6d7',
                itemHoverColor: '#1a92ac',
                inkBarColor: '#21b6d7',
            },
        },
    };


    const {
        token: { colorBgContainer },
    } = theme.useToken();

    const getItem = (label, key, icon, href, children) => {
        return {
            key,
            icon,
            label: href ? <Link to={href}>{label}</Link> : label,
            children,
        };
    }

    const adminItems = [
        ...(Tran.length > 0
            ? [
                ...Tran.filter((item) => item.TranType === "RoomChat").map((idx) =>
                    getItem(
                        idx.TranName,
                        idx.TranIdx,
                        <CommentOutlined />,
                        `/dashboard/${idx.TranType.toLowerCase()}`
                    )
                ),
            ]
            : []),
        ...(Tran.length > 0
            ? [
                getItem("Master", "Master", <AppstoreAddOutlined />, null, [
                    ...Tran.filter((item) => item.TranType === "Master").map((idx) =>
                        getItem(
                            idx.TranName,
                            idx.TranIdx,
                            "",
                            `/dashboard/${idx.TranType.toLowerCase()}/${idx.TranFormName.toLowerCase()}`
                        )
                    ),
                ]),
            ]
            : []),
        ...(Tran.length > 0
            ? [
                getItem("Configuration", "Configuration", <SettingOutlined />, null, [
                    ...Tran.filter((item) => item.TranType === "Configuration").map((idx) =>
                        getItem(
                            idx.TranName,
                            idx.TranIdx,
                            "",
                            `/dashboard/${idx.TranType.toLowerCase()}/${idx.TranFormName.toLowerCase()}`
                        )
                    ),
                ]),
            ]
            : []),
    ];

    const sidebarItems = [

        ...(Tran.length > 0
            ? [
                ...Tran.filter((item) => item.TranType === "Dashboard").map((idx) =>
                    getItem(
                        idx.TranName,
                        1,
                        <PieChartOutlined />,
                        `/${idx.TranType.toLowerCase()}`
                    )
                ),
            ]
            : []),

        ...(Tran.length > 0
            ? [
                getItem("MenuOrder", "MenuOrder", <SettingOutlined />, null, [
                    ...Tran.filter((item) => item.TranType === "MenuOrder").map((idx) =>
                        getItem(
                            idx.TranName,
                            idx.TranIdx,
                            "",
                            `/dashboard/${idx.TranType.toLowerCase()}/${idx.TranFormName.toLowerCase()}`
                        )
                    ),
                ]),
            ]
            : []),

        ...(Tran.length > 0
            ? [
                ...Tran.filter((item) => item.TranType === "Invoice").map((idx) =>
                    getItem(
                        idx.TranName,
                        idx.TranIdx,
                        <FileSyncOutlined />,
                        `/dashboard/${idx.TranType.toLowerCase()}`
                    )
                ),
            ]
            : []),

        ...(Tran.length > 0
            ? [
                ...Tran.filter((item) => item.TranType === "Analytic").map((idx) =>
                    getItem(
                        idx.TranName,
                        idx.TranIdx,
                        <LineChartOutlined />,
                        `/dashboard/${idx.TranType.toLowerCase()}`
                    )
                ),
            ]
            : []),

        ...(userData.Role === "Admin" ? adminItems : []),
    ];

    const handleMenuClick = (e) => {
        // Save the clicked menu key to localStorage
        if (mobile) {
            setCollapsed(true);
        }
        localStorage.setItem('selectedMenuKey', e.key);
        setSelectedKeys([e.key]);
    };

    const handleOpenChange = (keys) => {
        // Save the open keys to localStorage
        localStorage.setItem('openMenuKeys', JSON.stringify(keys));
        setOpenKeys(keys);
    };

    const handleSignOut = () => {
        Cookies.remove('auth_token');
        localStorage.clear();
        message.success('You have successfully signed out.');
        navigate('/');
        // window.location.reload();
    };


    const menuItems = [
        {
            key: 'Account',
            icon: <UserOutlined />,
            label: <Link to={`/dashboard/profile`}>Profile</Link>,
        },
        {
            type: 'divider',
        },
        {
            key: 'Logout',
            icon: <LogoutOutlined />,
            label: <button onClick={handleSignOut}>Logout</button>,
        },
    ];

    return (
        <ConfigProvider theme={customTheme}>
            <Layout style={{ minHeight: "100vh" }}>
                {!mobile || (mobile && !collapsed) ? (
                    <Sider
                        trigger={null}
                        collapsible
                        collapsed={collapsed}
                        width={250}
                        style={{
                            overflow: "auto",
                            height: "100vh",
                            position: "fixed",
                            left: 0,
                            top: 0,
                            bottom: 0,
                            background: "#FFC700", // Mengubah background sidebar menjadi warna primary
                            color: "#000000",      // Mengubah warna teks sidebar menjadi hitam
                            zIndex: 10
                        }}
                    >
                        <div className="demo-logo-vertical" />
                        <div className="w-full p-4">
                            {!collapsed ? (
                                <img src="/assets/images/logo-name-2.png" alt="Logo" className="w-32" />
                            ) : (
                                <img src="/assets/images/icon-2.png" alt="Logo" className="w-28" />
                            )}
                        </div>
                        <Menu
                            theme="light"
                            mode="inline"
                            selectedKeys={selectedKeys}
                            openKeys={openKeys}
                            items={sidebarItems}
                            onClick={handleMenuClick}
                            onOpenChange={handleOpenChange}
                            style={{
                                background: "#FFC700",
                                color: "#FFFFFF"
                            }}
                        />
                    </Sider>
                ) : null}
                <Layout
                    style={{
                        marginLeft: mobile && collapsed ? 0 : (collapsed ? 80 : 250),
                        transition: "margin-left 0.2s",
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <Header
                        style={{
                            padding: 0,
                            background: colorBgContainer,
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            position: 'sticky',
                            top: 0,
                            zIndex: 99,
                            width: '100%',
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                            backgroundColor: "#000000",
                            color: "#FFFFFF"
                        }}
                    >
                        <Button
                            type="text"
                            icon={collapsed ? <DoubleRightOutlined className="hover:scale-110 transition-all duration-150" /> : <DoubleLeftOutlined className="hover:scale-110 transition-all duration-150" />}
                            onClick={() => setCollapsed(!collapsed)}
                            style={{
                                fontSize: "16px",
                                width: 42,
                                height: 42,
                                color: "#FFFFFF"
                            }}
                        />

                        <Dropdown menu={{ items: menuItems }} trigger={['click']}>
                            <div className="flex items-center justify-center gap-2 mr-5 cursor-pointer">
                                <div className="border rounded-full p-2 flex items-center justify-center">
                                    <UserOutlined style={{ fontSize: '16px' }} />
                                </div>
                                {/* <p>{userData && userData.Username}</p> */}
                            </div>
                        </Dropdown>
                    </Header>

                    <Content
                        style={{
                            padding: "24px 16px",
                            overflow: "initial",
                            flex: 1,
                            paddingTop: "10px",
                            background: "#8080800D"
                        }}
                    >
                        {children}
                        {(Role === "User" || Role === "user") && (
                            <LiveChat />
                        )}
                    </Content>
                </Layout>
            </Layout>
        </ConfigProvider>
    );
};

export default Layouts;